import React from "react";
import { Link } from "react-router-dom";
import { SupportHeader } from "@/components/support/SupportHeader";
import { SupportForm } from "@/components/support/SupportForm";

export default function Support() {
  return (
    <div className="min-h-screen bg-background px-4 sm:px-6 lg:px-8 animate-fade-in">
      <div className="max-w-2xl mx-auto space-y-8">
        <SupportHeader />
        <SupportForm />
        <div className="text-center text-sm text-muted-foreground pb-8">
          <p>
            Need immediate assistance?{" "}
            <Link to="/faq" className="text-primary hover:underline">
              Check our FAQ
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}